import moment from 'moment'
const ONLINE_THRESHOLD = 5
export const getHumanReadableMomentFromStamp = timeStamp=>{
    return moment(timeStamp).from()
} 

export const getFormattedFromStamp = timeStamp=>{
    return moment(timeStamp).format("DD-MMM-YYYY HH:MM")
}

export const isOnline = (lastActiveUnixStamp)=>{
    const lastActiveMoment = moment.unix(lastActiveUnixStamp);
    const now = moment();
    const diff_in_minutes = now.diff(lastActiveMoment,"minutes");
    return diff_in_minutes <= ONLINE_THRESHOLD
}